import { FunctionComponent } from "react";

import { SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

import { TextField } from "@mui/material";

import { Modal } from "@/components";
import { getAllErrors, renderErrorMessages } from "@/utils";

import { TrackerPerson } from "../../schema/trackerPerson";

interface RemovePersonModalProps {
	showRemovePerson: boolean;
	setShowRemovePerson: (value: boolean) => void;
	handleRemovePersonFromTrackerOrganization: () => void;
	removePersonIsLoading: boolean;
	selectedTrackerPerson?: TrackerPerson;
	errorRemoving?: FetchBaseQueryError | SerializedError;
	ts: (key: string) => string;
}

export const RemovePersonModal: FunctionComponent<RemovePersonModalProps> = ({
	showRemovePerson,
	setShowRemovePerson,
	handleRemovePersonFromTrackerOrganization,
	removePersonIsLoading,
	selectedTrackerPerson,
	errorRemoving,
	ts,
}) => {
	if (!showRemovePerson) {
		return null;
	}

	return (
		<Modal
			handleClose={() => setShowRemovePerson(false)}
			handleSave={handleRemovePersonFromTrackerOrganization}
			isLoading={removePersonIsLoading}
			isOpened={showRemovePerson}
			submitButtonColor="error"
			submitButtonText={"Remove"}
			title={"Remove person from tracker"}
		>
			<div className="text-sm text-gray-700 mb-4">
				Are you sure you want to remove this person from the tracker?
			</div>
			<TextField
				fullWidth
				defaultValue={selectedTrackerPerson?.name}
				inputProps={{ readOnly: true }}
				label={ts("name")}
			/>
			{getAllErrors(errorRemoving, []).length
				? renderErrorMessages(getAllErrors(errorRemoving, []))
				: null}
		</Modal>
	);
};
